<template>
    <div class="about bg">
        <headerCom></headerCom>        
        <div class="width title-box">
            <p class="title">新闻动态</p>
            <p class="line">—</p>
            <p class="title-en">news center</p>
        </div>
        <div class="width list-box">
            <div class="item-box" v-for="item in articleList" :key="item.id">
                <div class="left" v-if="item.articleCover!=''">
                    <div>
                        <img :src="httpUrl + '/disk/' + item.articleCover" alt="" />
                    </div>
                </div>
                <div class="right" v-if="item.articleCover!=''">
                    <div class="time-box">
                        <div class="time">
                            <p class="day">{{item.articleTime.split(' ')[0].split('-')[2]}}</p>
                            <p class="year">{{item.articleTime.split('-')[0]}}.{{item.articleTime.split('-')[1]}}</p>
                        </div>
                    </div>
                    <div class="content-box">
                        <p class="item-title">
                            {{item.title}}
                        </p>
                        <p class="item-content" v-html="item.content">
                        </p>
                        <div class="btn" @click="linkTo('/newsDetail',item.id)">
                            查看详情
                        </div>
                    </div>
                </div>
                <div class="right right2" v-else>
                    <div class="time-box">
                        <div class="time">
                            <p class="day">{{item.articleTime.split(' ')[0].split('-')[2]}}</p>
                            <p class="year">{{item.articleTime.split('-')[0]}}.{{item.articleTime.split('-')[1]}}</p>
                        </div>
                    </div>
                    <div class="content-box">
                        <div class="l">
                            <p class="item-title">
                                {{item.title}}
                            </p>
                            <p class="item-content" v-html="item.content">
                            </p>
                        </div>
                        <div class="btn-box">
                            <div class="btn" @click="linkTo('/newsDetail',item.id)">
                                                        查看详情
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="pagination.currentPage"
                :page-size="pagination.pageSize"
                layout="prev, pager, next, jumper"
                :total="pagination.total"
                background
            >
            </el-pagination>
        </div>
        <!-- <img src="" alt="" srcset=""> -->
        <!-- <footerCom></footerCom> -->
    </div>
</template>
<script>
// import footerCom from "../components/Footer";
import headerCom from "../components/header";
import { articleListByPage } from "../api/newstendency.js";

export default {
    name: "newstendency",
    components: {
        // footerCom,
        headerCom
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            pagination: {
                pageSize: 10,
                currentPage: 1,
                total: null,
            },
            articleList: [],
        };
    },
    methods: {
        // 跳转
        linkTo(path,id) {
            this.$router.push({
                path: path,
                query: {
                    id:id
                },
            });
        },

        handleCurrentChange(currentPage) {
            // console.log(currentPage);
            this.pagination.currentPage = currentPage;
            this.articleListByPageFun();
        },

        //列表
        articleListByPageFun() {
            articleListByPage(this.pagination)
                .then((res) => {
                    if (res.code == 200) {
                        this.articleList = res.data.list;
                        this.pagination.total = res.data.total;
                    }
                })
                .catch((err) => {
                    this.$message(err.message);
                });
        },
    },
    created() {
        this.pagination.currentPage = 1;
        this.articleListByPageFun();
    },
};
</script>
<style lang="less" scoped>
@import "../assets/css/base.less";
.about {
    .title-box {
        // position: relative;
        padding-bottom: 25px;
        border-bottom: 2px solid #d6dcea;
        p {
            text-align: center;
        }
        .title {
            margin-top: 25px;
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #345197;
        }
        .line {
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #345197;
            height: 20px;
            line-height: 20px;
        }
        .title-en {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #345197;
        }
    }
    .list-box {
        // width: 100%;
        padding-bottom: 100px;
        display: flex;
        flex-direction: column;

        .item-box {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 1px solid #d6dcea;
            padding: 50px 0;

            .left {
                width: 33%;
                height: 243px;
                div {
                    width: 385px;
                    height: 243px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: auto;
                    }
                }
            }
            .right {
                width: 785px;
                height: 243px;
                padding-left: 200px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .time-box {
                    width: 110px;
                    text-align: center;
                    .time {
                        width: 102px;
                        height: 102px;
                        border: 1px solid #34529771;
                        // opacity: 0.4;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        color: #345197;
                        .day {
                            font-size: 34px;
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            color: #345197;
                            margin-bottom: 5px;
                        }
                        .year {
                            font-size: 18px;
                            font-family: Source Han Sans CN;
                            font-weight: 500;
                            color: #345197;
                        }
                    }
                }
                .content-box {
                    width: 100%;
                    margin-left: 40px;
                    display: flex;
                    flex-direction: column;
                    // justify-content: space-between;
                    position: relative;
                    .item-title {
                        width: 75%;

                        font-size: 24px;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;

                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }
                    .item-content {
                        margin-top: 20px;
                        font-size: 14px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #999999;

                        line-height: 26px;

                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        line-clamp: 4;
                        -webkit-box-orient: vertical;
                    }
                    .btn {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 180px;
                        height: 42px;
                        background: #345197;
                        border-radius: 4px;
                        font-size: 16px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #ffffff;
                        line-height: 42px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
            .right2{
                width: 100%;
                padding:0 40px;
                padding-left: 0;
                height: auto !important;
                .content-box{
                    display: flex;
                    justify-content: space-between;
                    flex-direction:initial;
                    .l{
                        width:calc(100% - 250px) ;
                    }
                    .item-content{
                           word-wrap: break-word;   
                            word-break: break-all;  
                            overflow: hidden;     
                            text-overflow: ellipsis;  
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            max-height: 78px;
                    }
                }
                .btn-box{
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                }
                .btn{
                    position: relative !important;
                }
            }
        }
    }
}
/deep/ .el-pagination {
    margin-top: 50px;
    text-align: end;
}
@media screen and (max-width: 1650px) {
    .about .title-box .tips-box {
        font-size: 16px;
    }
    .about .title-box .tips-box img {
        width: 14px;
    }
}
@media screen and (max-width: 1450px) {
    .about .title-box .tips-box {
        font-size: 14px;
    }
    .about .title-box .tips-box img {
        width: 12px;
    }
}

/deep/.el-timeline-item__tail {
    // top: 50%;
    top: 0;
    left: 7px;
    padding-top: 10%;
    display: block !important;
}
/deep/ .el-timeline-item__node {
    top: calc(50% - 20px);
    background: url(../assets/images/line-time.png) no-repeat center center;
    background-size: 100% 100%;
    width: 18px;
    height: 18px;
    // margin-bottom: 10px;
}
</style>

<style>
.el-popper .popper__arrow::after {
    content: none;
}
.el-popper[x-placement^="bottom"] {
    margin-top: 0;
    margin-right: -30px;
    /* padding: 0 20px; */
}
.el-popper[x-placement^="bottom"] .popper__arrow {
    display: none;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 0;
    box-shadow: none;
}
.el-dropdown-menu__item {
    color: #ccc;
    width: 110px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown {
    color: #ccc;
    font-size: 16px;
}
</style>

